import { NgModule, InjectionToken, ModuleWithProviders, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ThemeComponent } from './theme.component';
import { ThemeService, FakeThemeService } from './theme.service';
import { ThemeLoaderService } from './theme-loader.service';

export const THEME_TOKEN = new InjectionToken('Theme Token');

export class ThemeName {
  constructor(private themeService: ThemeService) { }

  get themeId() {
    return this.themeService.currentTheme.themeId;
  }
}

export function themeConfigFactory(themeService: ThemeService): ThemeName {
  return new ThemeName(themeService);
}

export interface ThemeModuleConfig {
  themeLoader: Provider;
}

@NgModule({
  imports: [CommonModule, RouterModule.forChild([]), MatProgressSpinnerModule],
  declarations: [ThemeComponent],
  exports: [ThemeComponent]
})
export class ThemeModule {

  static forRoot(config: ThemeModuleConfig): ModuleWithProviders {
    return {
			ngModule: ThemeModule,
      providers: [
        config.themeLoader || { provide: ThemeService, useClass: FakeThemeService },
        {
          provide: ThemeName,
          useFactory: themeConfigFactory,
          deps: [ThemeService]
        },
        ThemeLoaderService
      ]
    }
  }
}
